'use es6';

import { VISITOR } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import { getSenderType } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getQuickReply } from 'conversations-message-history/common-message-format/operators/cmfQuickReplyGetters';
export const getHasQuickReplyOptions = message => {
  const currentMessageSenderType = getSenderType(message);
  return getQuickReply(message) && currentMessageSenderType !== VISITOR;
};